
export default class messageUtils{

  static successMsg(script,str) {
    script.$message({
      message: str,
      type: 'success'
    });
  }
  static errorMsg(script,str) {
    script.$message.error(str);
  }

  static warningMsg(script,str){
    script.$message({
      message: str,
      type: 'warning'
    });
  }
}



// WEBPACK FOOTER //
// ./src/utils/messageUtils.js